module.exports = __webpack_public_path__ + "static/media/ins.34cf999f.png";